<template>
  <div class="user-detail-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="info-box">
          <div class="title">提现信息：</div>
          <div class="info">
            <div class="single">
              <p class="label">系统：</p>
              <p class="text">{{ userDetail.sys }}</p>
            </div>
            <div class="single">
              <p class="label">用户ID：</p>
              <p class="text">{{ userDetail.uid }}</p>
            </div>
            <div class="single">
              <p class="label">用户昵称：</p>
              <p class="text">{{ userDetail.nickname }}</p>
            </div>
            <div class="single">
              <p class="label">账户：</p>
              <p class="text">{{ accTypeMap[userDetail.accType] || "" }}</p>
            </div>
            <!-- <div class="single">
                <p class="label">微信头像： </p>
                <el-image
                  class="img"
                  :src="userDetail.avatar"
                  fit="cover"
                ></el-image>
              </div> -->

            <div class="single">
              <p class="label">提现金额：</p>
              <p class="text">{{ userDetail.balance }}</p>
            </div>
            <div class="single">
              <p class="label">实到金额：</p>
              <p class="text">{{ userDetail.actualBalance }}</p>
            </div>
            <div class="single">
              <p class="label">公司营业执照：</p>
              <el-image
                class="img"
                :src="userDetail.license"
                :preview-src-list="[userDetail.license]"
                fit="cover"
              ></el-image>
            </div>
            <div class="single">
              <p class="label">身份证正反面：</p>
              <el-image
                class="img"
                :src="userDetail.frontPic"
                :preview-src-list="[userDetail.frontPic, userDetail.behindPic]"
                fit="cover"
              ></el-image>
              <el-image
                class="img"
                :src="userDetail.behindPic"
                :preview-src-list="[userDetail.frontPic, userDetail.behindPic]"
                fit="cover"
              ></el-image>
            </div>
            <div class="single">
              <p class="label">身份证号：</p>
              <p class="text">{{ userDetail.idNumber }}</p>
            </div>
            <div class="single">
              <p class="label">收款账号：</p>
              <p class="text">{{ userDetail.card }}</p>
            </div>
            <div class="single">
              <p class="label">开户行：</p>
              <p class="text">{{ userDetail.openBank }}</p>
            </div>
            <div class="single">
              <p class="label">账户名称：</p>
              <p class="text">{{ userDetail.cardName }}</p>
            </div>
            <div class="single">
              <p class="label">联系人电话：</p>
              <p class="text">{{ userDetail.phone }}</p>
            </div>
            <div class="single" v-if="userDetail.proof">
              <p class="label">电子发票：</p>
              <el-image
                class="img"
                :src="userDetail.proof"
                :preview-src-list="[userDetail.proof]"
                fit="cover"
              ></el-image>
            </div>
            <div class="single">
              <p class="label">审核状态：</p>
              <p class="text" style="color:#9C3D92">
                {{ statusMap[userDetail.status] }}
              </p>
            </div>
            <div class="single" v-if="userDetail.remark">
              <p class="label">驳回原因：</p>
              <p class="text" style="color:#9C3D92">
                {{ userDetail.remark }}
              </p>
            </div>
            <div class="single">
              <p class="label">创建时间：</p>
              <p class="text">{{ userDetail.created }}</p>
            </div>
            <div class="single">
              <p class="label">审核日期：</p>
              <p class="text">{{ userDetail.auditTime }}</p>
            </div>
          </div>
        </div>

        <div class="bootom-btn" v-if="userDetail.status == 1">
          <div class="btn1" @click="rejectHandler(2)">
            驳回
          </div>
          <div class="btn2" @click="rejectHandler(1)">
            同意
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '@/components/common/header';
import { logo } from '../../config';
export default {
  components: {
    Header
  },
  name: 'user-detail',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '资金管理',
        secondTitle: '提现详情'
      },
      id: null,
      userDetail: {
        info: {},
        superior: {},
        counter: {}
      },
      statusMap: {
        1: '待审核',
        2: '审核通过',
        3: '审核驳回'
      },
      accTypeMap: {
        0: '私户',
        3: '公户'
      }
    };
  },
  mounted() {
    // 获取用户详情
    let query = this.$route.query;
    if (query.id) {
      this.id = +query.id;
      this.getUserDetail();
    }
  },
  computed: {},
  methods: {
    // 获取用户详情
    getUserDetail() {
      this.loading++;
      this.httpGet(this.$root.getBrandWithdrawInfo, {
        id: this.id
      }).then(
        (res) => {
          this.loading--;
          this.userDetail = res || {};
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },

  // 审核通过拒绝

    rejectHandler(status) {
      let url = '';
      if(status === 1){
        url = this.$root.passBrandWithdraw;
      } else {
        url = this.$root.refuteBrandWithdraw;
      }
      this.$confirm(`是否${status === 1 ? '通过' : '驳回'}此审核`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              this.loading++;
              this.httpPut(url, {
                id: this.id,
              }).then(
                (res) => {
                  this.loading--;
                  this.getUserDetail();
                  this.$message({
                    message: '操作成功',
                    type: 'success'
                  });
                },
                (res) => {
                  this.loading--;
                  this.$message.error(res);
                }
              );
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作!'
          });
        });
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.user-detail-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 10px;

    // content 表格
    .content {
      width: 100%;
      font-size: 14px;
      box-sizing: border-box;
      border-radius: 2px;
      flex-y(flex-start, flex-start);
      background: white;

      .info-box {
        flex-y(flex-start, flex-start);
        padding: 24px 50px 24px 32px;
        background: white;
        box-sizing: border-box;
        height: 100%;
        width: 100%;
        margin-bottom: 12px;

        .title {
          font-size: 18px;
          color: gray3;
          width: 225px;
          min-width: 225px;
        }

        .info {
          flex-y(flex-start, flex-start);
          margin-top: 30px;
          margin-left: 100px;

          .single {
            display: flex;
            align-items center
            margin-top 5px
            .label {
              word(14px, gray3);
              line-height: 2;
              white-space: nowrap;
              margin-right :30px;
              text-align right
              width :100px;
            }
            .text{
              word(14px, gray6);

            }
            .img{
              width: 49px;
              min-width: 49px;
              height: 49px;
              min-height: 49px;
              // border-radius: 49px;
              margin-bottom: 8px;
            }
          }
        }

        .img-box {
          flex-y(center, flex-start);
          width: 225px;
          min-width: 225px;
          white-space: nowrap;
          word(14px, gray3);

          >div {
            flex-y(center, center);
          }

          .img {
            width: 90px;
            min-width: 90px;
            height: 90px;
            min-height: 90px;
            border-radius: 45px;
            margin-bottom: 8px;
          }
        }
      }

      .bootom-btn{
        border 1px solid  #F6F6F6;
        width 100%
        height 80px
        background #fff
        display flex
        justify-content center
        align-items center

        .btn1{
          width 125px;
          height 40px;
          border 1px solid #979797
          font-size 16px
          line-height 40px
          text-align center
          color #666
          border-radius 4px
          box-sizing border-box
          margin-right 30px
          cursor pointer
        }
         .btn2{
          width 125px;
          height 40px;
          font-size 16px
          line-height 40px
          text-align center
          background #9C3D92
          border-radius 4px
          color #fff
          cursor pointer
        }
      }
    }
  }
}
</style>
